import { memo } from 'react';

import { Heading, useTheme, VStack } from '@chakra-ui/react';

import { LocationInterface } from 'types';

import { Divider } from 'ui';
import { LocationItem } from '../LocationItem';

interface LocationBlockProps {
  locations: LocationInterface[];
  state: string;
  label?: string;
  onSelectLocation: (item: LocationInterface) => void;
  onFavoriteIconClick: (isSelected: boolean, locationId: number) => void;
  isHidedHeader?: boolean;
  isMain?: boolean;
  favoriteLocationIds?: number[];
  isLogged?: boolean;
  isDistanceHide?: boolean;
}

const LocationBlock = ({
  locations,
  state,
  label,
  onSelectLocation,
  onFavoriteIconClick,
  isHidedHeader = false,
  isMain = false,
  favoriteLocationIds = [],
  isLogged = true,
  isDistanceHide = false
}: LocationBlockProps) => {
  const {
    colors: {
      palette: {
        components: { locations: styles }
      }
    }
  } = useTheme();

  return (
    <VStack
      gap={0}
      borderTopRadius={isHidedHeader ? 0 : '12px'}
      borderBottomRadius={isMain ? '12px' : 0}
      mb={isMain ? '35px' : '30px'}
      overflow='hidden'
      w='full'
    >
      {!isHidedHeader ? (
        <VStack h='40px' w='full' bg={styles.headingBg} justifyContent='center'>
          <Heading
            variant='h2'
            as='h2'
            fontWeight='bold'
            color={styles.headingColor}
            fontSize={['16px', '18px', '21px']}
            textAlign='center'
            textTransform='uppercase'
          >
            {label ?? state}
          </Heading>
        </VStack>
      ) : (
        <Divider borderColor={styles.itemBorder} />
      )}
      {locations.map((locationItem: LocationInterface, index: number) => (
        <LocationItem
          key={locationItem.id}
          item={locationItem}
          onSelectCard={() => onSelectLocation(locationItem)}
          onToggle={onFavoriteIconClick}
          isMain={isMain}
          isActive={isMain}
          isLast={index === locations.length - 1}
          isFavorite={favoriteLocationIds.includes(locationItem.id)}
          isLogged={isLogged}
          isDistanceHide={isDistanceHide}
        />
      ))}
    </VStack>
  );
};

export default memo(LocationBlock);
